module.exports = __webpack_public_path__ + "static/img/XZZX-40.6984f41.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/base/XZZX-40.jpg
// module id = 4xJP
// module chunks = 1